export default __webpack_public_path__ + "static/media/gasag_grid_xl.d2cdc36b.jpg";